module.exports = __webpack_public_path__ + "static/media/logo.6e6ded0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kiffgo/logo.svg
// module id = 653
// module chunks = 0